import { useAuthContext } from 'components/Login/hooks';
import { useHelpscoutMigration } from 'customer/components/help/Helpscout/hooks';
import { useAppContext } from 'customer/context';
import useStyles from 'isomorphic-style-loader-react18/useStyles';
import s from './Header.less';
import HelpscoutNotificationsButton from './HelpscoutNotificationsButton';
import hamburger from './hamburger.svg';

interface HeaderProps {
  setShowSidebar: (show: boolean) => void;
}
const Header = ({ setShowSidebar }: HeaderProps) => {
  useStyles(s);

  const { isSuccess: authSuccess, data: authContext } = useAuthContext();
  const { isFeatureHelpscoutBeacon } = useAppContext();
  const { data: helpscoutMigration = {} } = useHelpscoutMigration(
    !!authContext?.userId,
  );
  const showHelpscoutNotifications =
    authSuccess && isFeatureHelpscoutBeacon && helpscoutMigration.migrated;

  return (
    <div className={s.root}>
      <div className="container">
        <div className="row g-0 align-items-center justify-content-between">
          <div className="col-auto d-lg-none">
            <button
              type="button"
              className={s.hamburgerBtn}
              onClick={() => {
                if (typeof setShowSidebar === 'function') setShowSidebar(true);
              }}
            >
              <img src={hamburger} className={s.hamburgerIcon} alt="Menu" />
            </button>
          </div>

          <div className="col-auto ms-auto"></div>

          {showHelpscoutNotifications && (
            <div className="col-auto w-auto">
              <HelpscoutNotificationsButton />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
